import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNonEmptyString, isNotNull, isNotNullish } from '@fmnts/core';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  EMPTY,
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from 'rxjs';
import { NextLocationApiActions } from './next-locations.actions';
import {
  selectCurrentLocationId,
  selectCurrentNextLocation,
} from './next-locations.selectors';

/**
 * Effects that take care to make sure that the location tracking
 * has the needed data available offline.
 */
@Injectable()
export class NextLocationsCacheEffects {
  /**
   * Request the location details when current location ID is set.
   */
  cacheCurrentLocation$ = createEffect(() => {
    return this.store.select(selectCurrentLocationId).pipe(
      filter(isNotNull),
      distinctUntilChanged(),
      map((locationId) =>
        NextLocationApiActions.getLocation.request({ locationId }),
      ),
    );
  });

  /**
   * Effect that requests the permit URL for offline availability whenever
   * the current location and permit URL changes.
   */
  cacheCurrentLocationPermit$ = createEffect(
    () => {
      return this.store.select(selectCurrentNextLocation).pipe(
        filter(isNotNullish),
        map((location) => location.permitUrl),
        filter(isNonEmptyString),
        distinctUntilChanged(),
        switchMap((permitUrl) =>
          this.http.get(permitUrl).pipe(catchError((e) => EMPTY)),
        ),
      );
    },
    { dispatch: false },
  );

  constructor(
    private store: Store,
    private http: HttpClient,
  ) {}
}
